import { useEffect } from "react";
import { NavbarHeader, PortalFooter } from "components/templates";
import { InsertDecagonProvider } from "providers/InsertDecagonProvider";
import { useAppContext } from "context/app-context";
import { useCartContext } from "context/cart-context";
import { NotificationBanner } from "components/UI/organisms";
import { guessIsWebView } from "services/webview";
import "./index.scss";

export const PageLayout = ({ children }) => {
  const { getSessionInfo, sessionInfo } = useAppContext();
  const { getInitialCards } = useCartContext();

  useEffect(() => {
    // fetch initial user session info
    getSessionInfo();
  }, [getSessionInfo]);

  useEffect(() => {
    // fetch user cart items if he had associated items with his ID
    sessionInfo?.userID && getInitialCards({ userID: sessionInfo.userID });
  }, [sessionInfo?.userID, getInitialCards]);

  return guessIsWebView() ? (
    <div className="webview-active">{children}</div>
  ) : (
    <>
      {sessionInfo?.featureToggles?.isDecagonEnabled && (
        <InsertDecagonProvider />
      )}
      <NavbarHeader />
      <NotificationBanner />
      {children}
      <PortalFooter />
    </>
  );
};
